import React from 'react';
import {Modal, Button, Icon} from '@/ui-kits';

interface CategoryMismatchModalProps {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  selectedCategory?: string;
  detectedCategory?: string;
}

export const CategoryMismatchModal: React.FC<CategoryMismatchModalProps> = ({
  open,
  onClose,
  onProceed,
}) => {
  return (
    <Modal
      open={open}
      className="p-0 w-[90%] sm:w-auto max-w-[500px] rounded-2xl">
      <div className="bg-white rounded-xl p-4 sm:p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 sm:top-4 sm:right-4 p-1 rounded-full">
          <Icon type="close" className="size-4 sm:size-5" />
        </button>

        <div className="flex flex-col items-center text-center mt-2 px-2 sm:px-4">
          <p className="text-ui_blue text-base sm:text-lg font-FigtreeSemiBold leading-relaxed mb-3">
            The uploaded document does not match the category of your selected
            specialist. Please re-upload the correct document.
          </p>

          <div className="my-2">
            <p className="text-ui_blue text-lg sm:text-xl font-FigtreeBold">
              OR
            </p>
          </div>

          <Button
            title="Proceed with AI-Recommended Specialist"
            variant="primary"
            size="lg"
            onClick={onProceed}
            className="w-full py-2 px-4 sm:px-6 rounded-md"
            textClassName="text-xs sm:text-sm font-PoppinsSemiBold"
          />
        </div>
      </div>
    </Modal>
  );
};
